// extracted by mini-css-extract-plugin
export default {"page":"c2-z","cartModal":"d2-z","checkout":"e2-z","placeholder":"f2-z","account":"g2-z"};